<template>
  <!--管理员-应聘管理 -->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("applicationManagement") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("addInfo")
        }}</el-button>
        <el-dropdown @command="handleUpdateAppStatus">
          <el-button type="primary" class="button-css">
            {{ $t("stateChange") }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item1, index) in statusData"
              :key="item1.code"
              :command="item1"
              >{{ item1.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-button class="button-css" @click="clickdeleteApplyJob">{{
          $t("delete")
        }}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 95%"
          height="520"
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
          v-loading="loading"
          @cell-click="educationDetail"
        >
          <!--------------选择框----------------->
          <el-table-column type="selection" width="45"> </el-table-column>
            <!-- ----------------------人材番号---------------------- -->
            <el-table-column
            prop="resumeId"
            label="人材番号"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData9"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- --------------------氏名------------------------ -->
          <el-table-column
            prop="name"
            label="氏名"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
           <!-- ----------------------案件番号---------------------- -->
           <el-table-column
            prop="jobId"
            label="案件番号"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseNumber") }}</p>
              <el-input
                v-model="searchData10"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------案件名---------------------- -->
          <el-table-column
            prop="businessName"
            label="案件名"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.jobName }}
            </template>
          </el-table-column>
          <!-- ----------------------教育機関番号---------------------- -->
          <el-table-column
            prop="educationId"
            label="教育機関番号"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationId") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------教育機関---------------------- -->
          <el-table-column
            prop="educationName"
            label="教育機関"
            width="130"
            @cell-click="educationDetail"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalInstitution") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------就職担当---------------------- -->
          <el-table-column
            prop="principal"
            label="就職担当"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("inauguration") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------医療機関番号---------------------- -->
          <el-table-column
            prop="medicalId"
            label="医療機関番号"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicId") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------医療機関---------------------- -->
          <el-table-column
            prop="medicalName"
            label="医療機関"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ----------------------採用担当 ---------------------- -->
          <el-table-column
            prop="username"
            label="採用担当"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("recruiter") }}</p>
              <el-input
                v-model="searchData8"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
          </el-table-column>
          <!-- ---------------------状态-------------------- -->
          <el-table-column
            prop="applyStatus"
            label="状态"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("applicationStatus") }}</p>
              <el-dropdown @command="handleCommandapplyStatus">
                <span class="el-dropdown-link">
                  {{ applyStatusName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item1, index) in applyStatusData"
                    :key="item1.code"
                    :command="item1"
                  >
                    {{ item1.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.applyStatus_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpapplyStatus_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------応募日付------------------------------------------->
          <el-table-column
            prop="createTime"
            label="応募日付"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("fundingDayPayment") }}</p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.createTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------書類選考結果------------------------------------------->
          <el-table-column
            prop="medSelection_dictText"
            label="書類選考結果"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope" >
              <p>{{ $t("bookTestResults") }}</p>
              <el-dropdown @command="handleCommandapplyOperate" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateList"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.medSelection_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpmedSelection_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduSelectionStatus"
            label="日付"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduSelectionStatus &&
                    scope.row.eduSelectionStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
           <!-------------------------------教育书类选考审核-------------------------------------------->
           <el-table-column
            prop="eduSelection_dictText"
            label="教育书类选考审核"
            width="200"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationBookSelectionExamination") }}</p>
              <el-dropdown @command="handleCommandapplyOperate6" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName6
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.eduSelection_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeduSelection_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduSelectionStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduSelectionStatus &&
                    scope.row.eduSelectionStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
          <!-------------------------------面接参加------------------------------------------->
          <el-table-column
            prop="medInterview_dictText"
            label="面接参加"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("faceAttending") }}</p>
              <el-dropdown @command="handleCommandapplyOperate1" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName1
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.medInterview_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpmedInterview_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduInterviewStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduInterviewStatus &&
                    scope.row.eduInterviewStatus.split(" ")[0]
                }}
              </p>
            </template>
            
          </el-table-column>
                    <!-------------------------------教育面试审核 -------------------------------------------->
                    <el-table-column
            prop="eduInterview_dictText"
            label="教育面试审核"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalInterviewReview") }}</p>
              <el-dropdown @command="handleCommandapplyOperate7" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName7
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.eduInterview_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeduInterview_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduInterviewStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduInterviewStatus &&
                    scope.row.eduInterviewStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
          <!-------------------------------医疗契约准备------------------------------------------->
          <el-table-column
            prop="medContractReadiness_dictText"
            label="医疗契约准备"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalContractPreparation") }}</p>
              <el-dropdown @command="handleCommandapplyOperate2"  v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName2
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.medContractReadiness_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpmedContractReadiness_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="medicalContractReadiness"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.medicalContractReadiness &&
                    scope.row.medicalContractReadiness.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
                    <!-------------------------------教育契约准备-------------------------------------------->
                    <el-table-column
            prop="educationContractReadiness_dictText"
            label="教育契约准备"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalCompactPreparation") }}</p>
              <el-dropdown @command="handleCommandapplyOperate8" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName8
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.educationContractReadiness_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeducationContractReadiness_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduContractReadiness"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduContractReadiness &&
                    scope.row.eduContractReadiness.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
          <!-------------------------------医疗再留资格办理------------------------------------------->
          <el-table-column
            prop="medResidence_dictText"
            label="医疗再留资格办理"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalResidencyEligibility") }}</p>
              <el-dropdown @command="handleCommandapplyOperate3" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName3
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.medResidence_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpmedResidence_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="medicalResidenceStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.medicalResidenceStatus &&
                    scope.row.medicalResidenceStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
            <!-------------------------------教育再留资格办理-------------------------------------------->
            <el-table-column
            prop="eduResidence_dictText"
            label="教育再留资格办理"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalResidencyEligibility") }}</p>
              <el-dropdown @command="handleCommandapplyOperate9" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName9
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.eduResidence_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeduResidence_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduResidenceStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduResidenceStatus &&
                    scope.row.eduResidenceStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
          <!-------------------------------医疗入境办理-------------------------------------------->
          <el-table-column
            prop="medImmigration_dictText"
            label="医疗入境办理"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalEntry") }}</p>
              <el-dropdown @command="handleCommandapplyOperate4" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName4
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.medImmigration_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpmedImmigration_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="medicalImmigrationStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.medicalImmigrationStatus &&
                    scope.row.medicalImmigrationStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
           <!-------------------------------教育入境办理-------------------------------------------->
           <el-table-column
            prop="eduImmigration_dictText"
            label="教育入境办理"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalEntry") }}</p>
              <el-dropdown @command="handleCommandapplyOperate10" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName10
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.eduImmigration_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeduImmigration_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduImmigrationStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduImmigrationStatus &&
                    scope.row.eduImmigrationStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
          <!-------------------------------医疗入社（成功） -------------------------------------------->
          <el-table-column
            prop="medMembership_dictText"
            label="日付"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalEnrollmentsSuccess") }}</p>
              <el-dropdown @command="handleCommandapplyOperate5" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName5
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.medMembership_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpmedMembership_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------医疗入社（成功）时间------------------------------------------->
          <el-table-column
            prop="medicalMembershipStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("MedicalEnrollmentSuccessTime") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.medicalMembershipStatus &&
                    scope.row.medicalMembershipStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
          <!-------------------------------教育入社（成功-------------------------------------------->
          <el-table-column
            prop="eduMembership_dictText"
            label="教育入社（成功）"
            width="190"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationallmentsSuccess") }}</p>
              <el-dropdown @command="handleCommandapplyOperate11" v-if="false">
                <span class="el-dropdown-link">
                  {{ applyOperateName11
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyOperateData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.eduMembership_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeduMembership_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-------------------------------日付------------------------------------------->
          <el-table-column
            prop="eduMembershipStatus"
            label="日付"
            width="120"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("date") }}</p>
            </template>
            <template slot-scope="scope">
              <p>
                {{
                  scope.row.eduMembershipStatus &&
                    scope.row.eduMembershipStatus.split(" ")[0]
                }}
              </p>
            </template>
          </el-table-column>
          <!-------------------------------应聘状态  entry freeEntry-------------------------------------------->
          <!-- <el-table-column
            prop="applyStatus"
            label="应聘状态"
            :show-overflow-tooltip="true"
            width="200px"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("applicationStatus") }}</p>
              <el-dropdown @command="handleCommandapplyStatus">
                <span class="el-dropdown-link">
                  {{ applyStatusName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyStatusData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.applyStatus_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpapplyStatus_dictText }}
              </span>
            </template>
          </el-table-column> -->
          <!--------------操作----------------->
          <el-table-column label="操作" fixed="right" width="100">
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <button class="save-button" @click="handleSaveClick">保存</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页部分-->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalNum"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!-- 添加人才绑定弹窗 -->
      <div class="employee-application" v-if="dialoghandleAdd">
        <div class="dialog-box-2">
          <!-- <div class="dialog-img-css">
            <div class="img-box">?</div>
          </div> -->
          <div class="dialog-title">
            {{ $t("addInfo") }}
          </div>
          <!--        信息栏-->
          <div class="info-box">
            <span class="info-box-span">{{ $t("caseName") }}</span>
            <div class="el-dropdown-class-normal">
              <el-dropdown @command="handleCommandJop">
                <span class="el-dropdown-link-normal">
                  {{ jobName
                  }}<img
                    src="./assets/Vector.png"
                    alt=""
                    class="info-img-css2"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in jobList"
                    :key="index"
                    :command="item"
                  >
                    {{ item.jobName }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <!--        信息栏-->
          <div class="info-box">
            <span class="info-box-span">{{ $t("dataName") }}</span>
            <div class="el-dropdown-class-normal">
              <el-dropdown @command="handleCommandPeoson">
                <span class="el-dropdown-link-normal">
                  {{ personnelName
                  }}<img
                    src="./assets/Vector.png"
                    alt=""
                    class="info-img-css2"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in personnelList"
                    :key="index"
                    :command="item"
                  >
                    {{ item.anonym }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-select v-model="value" class="select-input" placeholder="">
              <span class="el-dropdown-link-normal">
                <img src="./assets/Vector.png" alt="" class="info-img-css2" />
              </span>
    <el-option
      v-for="item in personnelList"
      :key="item.resumeId"
      :label="item.anonym"
      :value="item.resumeId">
    </el-option>
  </el-select> -->
            </div>
          </div>
          <div class="dialog-button">
            <button @click="addApplyJob">
              {{ $t("addInfo") }}
            </button>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialoghandleAddClose">×</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryAllApplyJob,
  deleteApplyJob,
  fuzzyApplyJob,
  insertApplyJob,
  updateAdminReviewStatus,
  updateApplyJob,
  updateJobStatus,
  updateApplyStatus,
  fuzzyQueryUserInfoAdmin,
  fuzzyQuery,
  fuzzyPersonnelQuery
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "administratorViewEducationalList",
  components: {
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    } //搜索部分的placeholder
  },
  data() {
    return {
      inputData1: "", //搜索框input内容
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第一个搜索
      searchData6: "", //表格第二个搜索
      searchData7: "", //表格第三个搜索
      searchData8: "", //表格第四个搜索
      searchData9: "", //表格第一个搜索
      searchData10: "", //表格第二个搜索
      searchData11: "", //表格第三个搜索
      searchData12: "", //表格第四个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageNumber: 1,
      pageSize: 15, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      educationId: "",
      multipleSelection: [],
      applyStatusChange: "",
      statusData: [],
      ApplyStatus: "",
      totalItem: 0,
      businessName: "",
      totalNum: 0,
      language: "",
      adminReviewStatus: "",
      adminReviewStatusName: "All",
      adminReviewStatusCode: "",
      adminReviewStatusData: [],
      applyOperate: "",
      applyOperateName: "All",
      applyOperateCode: "",
      applyOperateName1: "All",
      applyOperateCode1: "",
      applyOperateName2: "All",
      applyOperateCode2: "",
      applyOperateName3: "All",
      applyOperateCode3: "",
      applyOperateName4: "All",
      applyOperateCode4: "",
      applyOperateName5: "All",
      applyOperateCode5: "",
      applyOperateName6: "All",
      applyOperateCode6: "",
      applyOperateName7: "All",
      applyOperateCode7: "",
      applyOperateName8: "All",
      applyOperateCode8: "",
      applyOperateName9: "All",
      applyOperateCode9: "",
      applyOperateName10: "All",
      applyOperateCode10: "",
      applyOperateName11: "All",
      applyOperateCode11: "",
      applyOperateData: [],
      applyStatus: "",
      applyStatusName: "All",
      applyStatusCode: "",
      applyStatusData: [],
      dialoghandleAdd: false,
      jobList: [],

      personnelList: [],
      jobId: null,
      resumeId: null,
      personnelName: "",
      jobName: "",
      applyOperateList: []
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    this.getLanguage();
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    //全部查询
    this.clickQueryAllApplyJob();
    this.getReviewStatus();
    this.getadminReviewStatus();
    this.getapplyOperate();
    this.getapplyStatus();
    this.allCase();
    this.getallPersonnel();
    this.getapplyOperateList();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.clickQueryAllApplyJob();
        this.getReviewStatus();
        this.getadminReviewStatus();
        this.getapplyOperate();
        this.getapplyStatus();
      }
    },

    // 案件所有查询 list
    allCase() {
      const fakeInfo = {
        pageNumber: 1,
        pageSize: 1000,
        reviewStatus:2
      };
      fuzzyQuery(fakeInfo)
        .then(res => {
          if (res.data.code === "A0000") {
            console.log("--------案件所有查人才信息获取--------");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);

            this.jobList = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----案件所有列表信息失败----");
          console.log(res);
        });
    },
    getallPersonnel(id) {
      var fakeInfo2 = {
        applicationStatus: 1,
        pageNumber: 1,
        pageSize: 1000
      };
      fuzzyPersonnelQuery(fakeInfo2)
        .then(res => {
          console.log("--------所有人才信息获取--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.personnelList = aesFecInfo.data;
            console.log(this.personnelList);
          } else {
            this.$message.error("获取学生信息失败。");
          }
        })
        .catch(res => {});
    },
    addApplyJob() {
      var fakeInfo = {
        jobId: this.jobId,
        resumeId: this.resumeId
      };
      insertApplyJob(fakeInfo)
        .then(res => {
          console.log("--------教育机构人才信息获取--------");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$message.success(this.$t("addedSuccessfully"));
            this.dialoghandleAdd = false;
            this.jobId = "";
            this.resumeId = "";
            this.jobName = "";
            this.personnelName = "";
            this.clickQueryAllApplyJob();
          } else if (res.data.code === "A1103" && res.data.code === "A1104") {
            this.$message.error(this.$t("addNone"));
          } else if (res.data.code === "A1105") {
            this.$message.error(this.$t("addCheck"));
          } else if (res.data.code === "A1106") {
            this.$message.error(this.$t("addHave"));
          } else {
            this.$message.error(this.$t("addFailed"));
          }
        })
        .catch(res => {});
    },

    handleCommandJop(e) {
      console.log(e);
      this.jobId = e.jobId;
      this.jobName = e.jobName;
    },
    handleCommandPeoson(e) {
      console.log(e);
      this.resumeId = e.resumeId;
      this.personnelName = e.anonym;
    },
    //管理者变更应聘状态接口
    handleUpdateAppStatus(evt) {
      var adminUpdateJobStatusDTO = {
        applyId: this.applyId,
        applyStatus: evt.code
      };
      console.log(evt);
      updateApplyStatus(adminUpdateJobStatusDTO)
        .then(res => {
          console.log("--------管理者变更应聘状态接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            // this.$router.go(0)
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("解密后信息" + AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.clickQueryAllApplyJob();
            this.$message({
              message: this.$t("successfullyModified"),
              type: "success"
            });
          }
        })
        .catch(res => {
          console.log("管理者变更应聘状态接口异常:", res);
        });
    },

    //点击跳转教育机构详情
    educationDetail(row, column, cell, event) {
      console.log(event);
      console.log(column.label);
      console.log(row);
      var that = this;
      if (column.label == "教育機関") {
        this.educationId = row.educationId;
        console.log("这是真的");
        console.log(this.educationId);
        this.$router.push({
          name: "administratorsViewEducationInstitutionsClickDetails",
          query: {
            educationId: row.educationId
          }
        });
      }
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },

    // 管理员应聘所有查询 list
    clickQueryAllApplyJob() {
      let that = this;
      const fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      queryAllApplyJob(fakeInfo)
        .then(res => {
          console.log("----管理员应聘所有查询----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            that.tableData = aesFecInfo.data;
            that.totalNum = aesFecInfo.total;
          }
        })
        .catch(res => {
          console.log("----管理员案件所有应聘查信息失败----");
          console.log(res);
        });
    },

    //模糊查询
    inputSearch() {
      const fakeInfo = {
        adminReviewStatus: 0,
        applyStatus: this.applyStatusCode,
        createTimeEnd: "",
        createTimeStart: "",
        eduContractReadinessEnd: "",
        eduContractReadinessStart: "",
        eduImmigrationStatusEnd: "",
        eduImmigrationStatusStart: "",
        eduInterviewStatusEnd: "",
        eduInterviewStatusStart: "",
        eduMembershipStatusEnd: "",
        eduMembershipStatusStart: "",
        eduResidenceStatusEnd: "",
        eduResidenceStatusStart: "",
        eduSelectionStatusEnd: "",
        eduSelectionStatusStart: "",
        educationId: this.searchData3,
        educationName: this.searchData4,
        jobId: this.searchData10,
        jobName: this.searchData2,
        medcialContractReadinessEnd: "",
        medcialContractReadinessStart: "",
        medicalId: this.searchData6,
        medicalImmigrationStatusEnd: "",
        medicalImmigrationStatusStart: "",
        medicalInterviewStatusEnd: "",
        medicalInterviewStatusStart: "",
        medicalMembershipStatusEnd: "",
        medicalMembershipStatusStart: "",
        medicalName: this.searchData7,
        medicalResidenceStatusEnd: "",
        medicalResidenceStatusStart: "",
        medicalSelectionStatusEnd: "",
        medicalSelectionStatusStart: "",
        name: this.searchData1,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        principal: this.searchData5,
        resumeId: this.searchData9,
        username: this.searchData8
      };
      fuzzyApplyJob(fakeInfo)
        .then(res => {
          console.log("-----模糊查询接口-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.totalItem = aesFecInfo.total;
          }
        })
        .catch(res => {
          console.log("-----模糊查询接口-----");
          console.log(res);
        });
    },

    // 管理员删除应聘进度
    clickdeleteApplyJob() {
      const fakeInfo = {
        applyId: this.multipleSelection[0].applyId
      };
      deleteApplyJob(fakeInfo)
        .then(res => {
          console.log("----管理员删除应聘进度----");
          console.log(fakeInfo);

          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              message: this.$t("successfullyDeleted"),
              type: "success"
            });
            this.clickQueryAllApplyJob();
          }
        })
        .catch(res => {
          console.log("----管理员删除应聘进度失败----");
          console.log(res);
        });
    },
    // 教育机构模糊查询 list
    mohuSearch() {
      const fakeInfo = {
        address: this.searchData4,
        attributes: "",
        browseNumber: 0,
        casesNumber: this.searchData10,
        createTimeIn: "",
        createTimeOut: "",
        educationId: this.searchData1,
        educationName: this.searchData2,
        hpOrSns: this.searchData9,
        legalPerson: "",
        pageNumber: 1,
        pageSize: 15,
        postNumber: this.searchData3,
        status: this.searchData11,
        studentNumber: this.searchData8,
        teacherNumber: this.searchData7,
        telephone: this.searchData6,
        updateTimeIn: "",
        updateTimeOut: "",
        userName: this.searchData5
      };
      educationInfoFuzzyQuery(fakeInfo)
        .then(res => {
          console.log("----教育机构模糊查询列表信息----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----教育机构模糊查询列表信息----");
          console.log(res);
        });
    },
    //分页
    handleCurrentChange(evt) {
      this.currentPage = evt;
      console.log(this.currentPage);
      this.clickQueryAllApplyJob();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.getSelectJobInfo();
    },

    handleCommand01(command) {
      console.log(command);
      if (command === "a") {
        console.log("选择了YES");
      } else if (command === "b") {
        console.log("选择了NO");
      }
    },
    handleCommand02(command) {
      console.log(command);
      if (command === "a") {
        console.log("选择了2022.03.05");
      } else if (command === "b") {
        console.log("选择了2022.03.06");
      }
    },
    handleCommand03(command) {
      console.log(command);
      if (command === "a") {
        console.log("选择了未完成状态");
      } else if (command === "b") {
        console.log("选择了完成状态");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      this.applyId = this.multipleSelection[0].applyId;
      this.reviewStatus = this.multipleSelection[0].reviewStatus;

      console.log(this.reviewStatus);
    },
    handleAddClick() {
      console.log("＋新たなbutton");
      this.dialoghandleAdd = true;
      this.jobId = "";
      this.resumeId = "";
      this.jobName = "";
      this.personnelName = "";
    },
    dialoghandleAddClose() {
      this.dialoghandleAdd = false;
      this.jobId = "";
      this.resumeId = "";
      this.jobName = "";
      this.personnelName = "";
    },
    handleAlterClick() {
      console.log("状態変更button");
    },
    handleDeleteClick() {
      console.log("削除button");
    },
    // 员工保存
    handleSaveClick() {
      console.log("保存button");
    },
    //管理员申请
    managerApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 1 }
      });
    },
    // 管理员权限按钮
    handleIsShow() {},
    //获取adminReviewStatus下拉
    handleCommandadminReviewStatus(evt) {
      this.adminReviewStatusCode = evt.code;
      this.adminReviewStatusName = evt.name;
    },
    //获取applyOperate下拉
    handleCommandapplyOperate(evt) {
      this.applyOperateCode = evt.code;
      this.applyOperateName = evt.name;
    },
    handleCommandapplyOperate1(evt) {
      this.applyOperateCode1 = evt.code;
      this.applyOperateName1 = evt.name;
    },
    handleCommandapplyOperate2(evt) {
      this.applyOperateCode2 = evt.code;
      this.applyOperateName2 = evt.name;
    },
    handleCommandapplyOperate3(evt) {
      this.applyOperateCode3 = evt.code;
      this.applyOperateName3 = evt.name;
    },
    handleCommandapplyOperate4(evt) {
      this.applyOperateCode4 = evt.code;
      this.applyOperateName4 = evt.name;
    },
    handleCommandapplyOperate5(evt) {
      this.applyOperateCode5 = evt.code;
      this.applyOperateName5 = evt.name;
    },
    handleCommandapplyOperate6(evt) {
      this.applyOperateCode6 = evt.code;
      this.applyOperateName6 = evt.name;
    },
    handleCommandapplyOperate7(evt) {
      this.applyOperateCode7 = evt.code;
      this.applyOperateName7 = evt.name;
    },
    handleCommandapplyOperate8(evt) {
      this.applyOperateCode8 = evt.code;
      this.applyOperateName8 = evt.name;
    },
    handleCommandapplyOperate9(evt) {
      this.applyOperateCode9 = evt.code;
      this.applyOperateName9 = evt.name;
    },
    handleCommandapplyOperate10(evt) {
      this.applyOperateCode10 = evt.code;
      this.applyOperateName10 = evt.name;
    },
    handleCommandapplyOperate11(evt) {
      this.applyOperateCode11 = evt.code;
      this.applyOperateName11 = evt.name;
    },

    //获取applyStatus下拉
    handleCommandapplyStatus(evt) {
      this.applyStatusCode = evt.code;
      this.applyStatusName = evt.name;
      this.inputSearch()
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.applyStatusChange = "applyStatusChange";
        this.adminReviewStatus = "adminReviewStatus";
        this.applyOperate = "applyOperate";
        this.applyStatus = "applyStatus";
      } else {
        this.applyStatusChange = "jpapplyStatusChange";
        this.adminReviewStatus = "jpadminReviewStatus";
        this.applyOperate = "jpapplyOperate";
        this.applyStatus = "jpapplyStatus";
      }
    },
    getReviewStatus() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.applyStatusChange
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据review_status--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.statusData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");

            console.log(that.statusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getadminReviewStatus() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.adminReviewStatus
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log(
              "--------获取数据字典接口数据adminReviewStatus--------"
            );
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.adminReviewStatusData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.adminReviewStatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getapplyOperate() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.applyOperate
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据applyOperate--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.applyOperateData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.applyOperateData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    getapplyStatus() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.applyStatus
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据applyStatus--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.applyStatusData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.applyStatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getapplyOperateList() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: "statusName"
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据applyStatus--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.applyOperateList = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了1111--------");
            console.log(that.applyStatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}

.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.operate {
  /* height: 51px; */
}

.table {
  position: absolute;
  width: 92%;
  margin-top: 10px;
  height: 520px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}

.save-button {
  width: 69px;
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.pagination {
  width: 95%;
  height: 50px;
  margin-top: 590px;
}

.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.dialog-box {
  height: 630px;
  width: 400px;
  padding: 0 40px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}
.dialog-box-2 {
  width: 500px;
  height: 270px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}
.dialog-img-css {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-box {
  width: 66px;
  height: 66px;
  background: #fc630c;
  border-radius: 50%;
  text-align: center;
  line-height: 66px;
  font-size: 26px;
  font-weight: 500;
  color: #fff;
}
.dialog-title {
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #686868;
}
.employee-application {
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  display: flex;
  justify-content: center;
  /* align-items: center; */
}
.close-button {
  width: 50px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 700;
  font-size: 20px;
  color: #686868;
  cursor: pointer;
}
.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}
.dialog-button {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-button button {
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  color: #fc630c;
}
.info-box {
  width: 300px;
  height: 40px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 10px auto;
  position: relative;
}

.el-dropdown-class-normal {
  width: 300px;
  height: 40px;
}

.el-dropdown-link-normal {
  display: inline-block;
  width: 300px;
  height: 40px;
  line-height: 40px;
  padding: 0 40px 0px 15px;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  box-sizing: border-box;
}

.info-box-span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.info-img-css1 {
  border-radius: 50%;
}

.info-img-css2 {
  position: absolute;
  top: 10px;
  right: 20px;
}
.select-input {
  width: 280px;
  height: 20px !important;
}
.el-input__inner {
  color: #fff;
}
.el-input__inner:hover {
  color: #fff;
}
.el-input__suffix {
  /* display: none; */
}
.el-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorApplicationManagement/index.vue